import { ReactNode } from 'react';
import Clickable from './Clickable';
import styles from './styles/Switch.module.scss';
import cn from 'classnames';

export default function Switch<ValueType>({
  options,
  value,
  onChange,
  className,
  inline,
  renderOption = value => `${value}`
}: {
  options: ValueType[];
  value: ValueType;
  onChange: (value: ValueType) => void;
  className?: string;
  inline?: boolean;
  renderOption?: (value: ValueType) => ReactNode;
}) {
  function handleChange(v: ValueType) {
    if (v !== value) onChange(v);
  }

  return (
    <div className={cn(styles.Switch, className, { [styles.Inline]: inline })}>
      {options.map((option, i) => {
        return (
          <Clickable
            key={i}
            className={cn(styles.Item, { [styles.Selected]: JSON.stringify(option) === JSON.stringify(value) })}
            onClick={() => handleChange(option)}
          >
            {renderOption(option)}
          </Clickable>
        );
      })}
    </div>
  );
}
